/**
 *Server azure arc status enum.
 */
 export enum AzureArcStatusEnum {
    Connected = 'Connected',
    Disconnected = 'Disconnected',
    NotInstalled = 'NotInstalled',
    Unknown = 'Unknown',
    NotApplicableAzureVM = "NotApplicableAzureVM",
    NotApplicableCluster = "NotApplicableCluster",
    Expired = "Expired",
    InProgress = "InProgress",
    Failed = "Failed",
    Done = "Done",
    FetchingArcStatus = "FetchingArcStatus"
}
